import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"
import UploadIcon from "@mui/icons-material/Upload"
import { Box, Typography } from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import { FileUploadInput } from "graphql/types"
import { JSX, useState } from "react"
import Dropzone, { FileRejection } from "react-dropzone"

type ImageUploadProps = {
  onImageFileChosen: (files: File[]) => void
  onFileReject: (rej: FileRejection[]) => void
  image?: FileUploadInput | null
  accept?: { [key: string]: string[] }
  setImage: (arg: FileUploadInput | null) => void
  fullWidth?: boolean
  height?: number
}

export const ImageDropzone = (props: ImageUploadProps): JSX.Element => {
  const {
    onImageFileChosen,
    onFileReject,
    image,
    accept,
    setImage,
    fullWidth = false,
    height = 300,
  } = props
  const [dragOver, setDragOver] = useState<boolean>(false)

  const onDrop = (acceptedFiles: File[], fileRejections: FileRejection[]): void => {
    setDragOver(false)
    if (fileRejections.length > 0) {
      onFileReject(fileRejections)
    }
    if (acceptedFiles.length > 0) {
      onImageFileChosen(acceptedFiles)
    }
  }

  const onDelete = () => {
    setImage(null)
  }

  return (
    <Box
      style={{
        width: fullWidth ? "100%" : 300,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        style={{
          width: fullWidth ? "100%" : 300,
          height: height,
          border: `2px dashed #fff`,
          borderRadius: "10px",
        }}
      >
        <Dropzone
          accept={accept}
          maxSize={5242880}
          onDragEnter={() => {
            setDragOver(true)
          }}
          onDragLeave={() => {
            setDragOver(false)
          }}
          onDrop={onDrop}
        >
          {({
            getRootProps,
            getInputProps,
          }: {
            getRootProps: any
            getInputProps: any
          }): JSX.Element => (
            <>
              <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                flexDirection={"column"}
                {...getRootProps()}
                style={{ width: "100%", height: "100%" }}
              >
                <input {...getInputProps()} />

                <Typography
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "0 5%",
                    textAlign: "center",
                  }}
                  variant={"h6"}
                >
                  {image && image.base64 ? (
                    <>
                      <img
                        src={image.base64}
                        alt={image.name}
                        style={{
                          maxHeight: 270,
                          maxWidth: 270,
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <UploadIcon />
                      <br />
                      {dragOver ? (
                        "Drop file"
                      ) : (
                        <Box>
                          <StyledButton
                            buttonType="custom"
                            customText="Open File Dialog"
                            variant="contained"
                          />
                          <Typography>(.jpg, .gif, .png, .web) </Typography>
                          <Typography>(max. 5MB) </Typography>
                        </Box>
                      )}
                    </>
                  )}
                </Typography>
              </Box>
            </>
          )}
        </Dropzone>
      </Box>
      {image && image.name !== "" && (
        <Box
          sx={{
            pt: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle2">{image?.name}</Typography>
          <StyledButton
            buttonType="custom"
            customIcon={<DeleteOutlineIcon />}
            onClick={onDelete}
            variant="contained"
          />
        </Box>
      )}
    </Box>
  )
}
